<div class="tiptap-editor-sidebar">
  @let cards = (cards$ | async) ?? [];
  <div class="sidebar-top-bar">
    <div class="sidebar-tabs">
      @for (tab of tabs; track tab.id) {
        <button type="button" class="sidebar-tab" [class.active]="selectedTab === tab.id" (click)="selectTab(tab.id)">
          <span class="sidebar-tab-label">{{ tab.labelKey | translate }}</span>
          <span class="sidebar-tab-count">{{ cards.length }}</span>
        </button>
      }
    </div>
  </div>

  <div class="sidebar-content">
    @for (card of cards; track card.id) {
      <app-suggestion-card
        #cardRef
        [attr.data-suggestion-id]="card.id"
        [suggestionId]="card.id"
        [variant]="card.variant"
        [authorName]="card.authorName"
        [createdAtRelative]="card.createdAtRelative"
        [insertionRuns]="card.insertionRuns"
        [deletionRuns]="card.deletionRuns"
        [formattingText]="card.formattingText"
        [structureText]="card.structureText"
        [canResolve]="canResolve"
        [highlighted]="card.id === highlightedSuggestionId"
        [thread]="card.thread"
        [currentUser]="currentUser"
        [canPostComment]="canPostComment"
        (accept)="onAccept($event)"
        (reject)="onReject($event)"
        (view)="onView($event)"
        (submitComment)="onSubmitComment(card.id, $event)"
      ></app-suggestion-card>
    }
  </div>
</div>
